import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import {
  SurveyDialogProps,
  TRestraintDefaultValues,
} from 'routes/Main/Survey/type';
import MuiDialog from 'components/MuiDialog';
import { findKeyValueToStr } from 'utils/convert';
import { createRestraint } from 'apis/survey';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import Extroversion from './Extroversion';
import Contents from './Contents';
import CommonPatientInfo from '../../components/CommonPatientInfo';
import { useState } from 'react';

const Restraint = (props: SurveyDialogProps<TRestraintDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const [restraintList, setRestraintList] = useState<string[]>([]);

  const { handleSubmit, register, getValues, setValue, watch, control } =
    useForm({
      defaultValues,
    });

  const onSubmit = (data: TRestraintDefaultValues) => {
    const { apply, table_date, observation } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      medical_restraint_survey: {
        patient_id: patientInfo.patient_id,

        apply: findKeyValueToStr(apply),
        table_date,
        observation,
      },
    };

    createRestraint(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    control,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={2}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          신체보호대 적용 기록지
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <Extroversion
          restraintList={restraintList}
          setRestraintList={setRestraintList}
          {...formProps}
        />
        <Contents {...formProps} />
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default Restraint;
